import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { isMobile } from 'react-device-detect'
import { FormattedMessage, injectIntl } from 'react-intl'
import { DatePicker } from 'antd'

import styled from 'styled-components'
import _ from 'lodash'
import useGetCars from 'core/hooks/useGetCars'
import { Row, Col, ButtonPrimary, Select, Form } from 'core/components/ui'
import moment from 'moment'

import { tradeInShape } from '../../shapes'
import configurationShape from '../../../configuration/shapes'

const InputRow = styled(Row)`
  &&& {
    margin: ${isMobile ? '0px' : '25px 0 0'};
  }
`

const InputCol = styled(Col)`
  margin-bottom: ${isMobile && '20px'};
`

const SelectRow = styled(Row)`
  &&& {
    margin: ${isMobile ? '0px' : '12px 0'};
  }
`

const StyledSelect = styled(Select)`
  &&& {
    width: 100%;
    .ant-select-arrow {
      background: none;
      color: ${props => props.theme.colors.color1.bg};
    }
  }
`

const { MonthPicker } = DatePicker

const { Option } = Select

const ManualSelect = props => (
  <StyledSelect
    {...props}
    getPopupContainer={triggerNode =>
      triggerNode && triggerNode.parentElement ? triggerNode.parentElement : document.body
    }
  />
)

const ManualSearch = props => {
  const { intl, tradeIn, setTradeIn, configuration, form, showModal } = props
  const { vehicle } = tradeIn
  const {
    cars,
    appliedFilters,
    filters,
    loading,
    onChangeDate,
    onChangeMake,
    onChangeModel,
    onChangeEnergy,
    onChangeTrim,
    getCarsManually
  } = useGetCars({
    redirectMessage: intl.formatMessage({ id: 'ui-session-expired' }),
    maximumAgeTradeInCars: configuration.automaticValidationSetting.maximumAgeTradeInCars
  })
  const { filtersList } = tradeIn
  const { vehiclesList } = filtersList
  const handleValidateFilters = () => {
    getCarsManually()
  }

  const { automaticValidationSetting } = configuration
  const { maximumAgeTradeInCars } = automaticValidationSetting

  const changeDate = (type, value) => {
    const { campaign } = configuration
    const { deactivatedMakes } = campaign

    onChangeDate(type, value, deactivatedMakes)
  }

  const changeBrand = make => {
    onChangeMake(make)
  }

  const changeModel = model => {
    onChangeModel(model)
  }

  const changeEnergy = energy => {
    onChangeEnergy(energy)
  }

  const changeTrim = trim => {
    onChangeTrim(trim)
  }

  const disabledDate = current =>
    current &&
    (current > moment().endOf('day') ||
      (maximumAgeTradeInCars && current < moment().subtract(maximumAgeTradeInCars, 'years')))

  const { yearsList, monthsList, makesList, modelsList, energiesList, trimsList } = filters

  const renderOptions2 = aOptions =>
    aOptions.map(option => (
      <Option value={option.id} key={option.id}>
        {option.value}
      </Option>
    ))

  const { year, month, makeId, modelId, energyId, trimId, selectedDate } = appliedFilters

  useEffect(() => {
    if (vehiclesList && vehiclesList.length > 0) {
      const { wsDatas } = vehiclesList[0]
      if (wsDatas && wsDatas.putIntoService) {
        changeDate(3, wsDatas.putIntoService)
      }
    }
  }, [vehiclesList])

  useEffect(() => {
    const runIt = vehicleList => {
      const extendedFiltersList = {
        ...filtersList,
        vehiclesList: vehicleList
      }

      const newValues = form.getFieldsValue()
      const newVehicle = { ...vehicle, ...newValues }

      setTradeIn({
        ...tradeIn,
        filtersList: extendedFiltersList,
        vehicle: newVehicle
      })

      showModal()
    }
    if (cars.length > 0) runIt(cars)
  }, [cars])

  if (!yearsList || !monthsList) return null
  return (
    <>
      <SelectRow type="flex" gutter={20}>
        <InputCol span={isMobile ? 24 : 12}>
          <MonthPicker
            style={{ width: '100%' }}
            disabledDate={disabledDate}
            format="MMMM YYYY"
            onChange={value => {
              changeDate(3, value)
            }}
            disabled={loading}
            placeholder={intl.formatMessage({ id: 'select_date' })}
          />
        </InputCol>
      </SelectRow>
      <SelectRow type="flex" gutter={20}>
        <InputCol span={isMobile ? 24 : 12}>
          <ManualSelect
            id={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-3-placeholder'
            })}
            placeholder={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-3-placeholder'
            })}
            value={makeId !== null ? makeId : undefined}
            onChange={value => {
              changeBrand(value)
            }}
            loading={loading}
            disabled={loading || !year || !month}
            dropdownMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
          >
            {makesList && renderOptions2(makesList)}
          </ManualSelect>
        </InputCol>
        <InputCol span={isMobile ? 24 : 12}>
          <ManualSelect
            id={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-4-placeholder'
            })}
            placeholder={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-4-placeholder'
            })}
            value={modelId !== null ? modelId : undefined}
            onChange={value => {
              changeModel(value)
            }}
            loading={loading}
            disabled={loading || !makeId}
            dropdownMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
          >
            {modelsList && renderOptions2(_.sortBy(modelsList, 'value'))}
          </ManualSelect>
        </InputCol>
      </SelectRow>

      <SelectRow type="flex" gutter={20}>
        <InputCol span={isMobile ? 24 : 12}>
          <ManualSelect
            id={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-5-placeholder'
            })}
            placeholder={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-5-placeholder'
            })}
            value={energyId !== null ? energyId : undefined}
            onChange={value => {
              changeEnergy(value)
            }}
            loading={loading}
            disabled={loading || !modelId}
            dropdownMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
          >
            {energiesList && renderOptions2(energiesList)}
          </ManualSelect>
        </InputCol>
        <InputCol span={isMobile ? 24 : 12}>
          <ManualSelect
            id={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-6-placeholder'
            })}
            placeholder={intl.formatMessage({
              id: 'tradeIn-vehicle-homeTradeIn-card2-input-6-placeholder'
            })}
            value={trimId !== null ? trimId : undefined}
            onChange={value => {
              changeTrim(value)
            }}
            loading={loading}
            disabled={loading || !modelId}
            dropdownMatchSelectWidth={false}
            showSearch
            optionFilterProp="children"
          >
            {trimsList && renderOptions2(_.sortBy(trimsList, 'inclVatPrice'))}
          </ManualSelect>
        </InputCol>
      </SelectRow>
      <InputRow type="flex" justify="center">
        <Col>
          <ButtonPrimary
            onClick={handleValidateFilters}
            loading={loading}
            disabled={loading || !selectedDate || !makeId || !modelId || !trimId}
            dropdownMatchSelectWidth={false}
          >
            <FormattedMessage id="tradeIn-vehicle-homeTradeIn-card2-button" />
          </ButtonPrimary>
        </Col>
      </InputRow>
    </>
  )
}

ManualSearch.propTypes = {
  form: PropTypes.shape().isRequired,
  intl: PropTypes.shape().isRequired,
  setTradeIn: PropTypes.func.isRequired,
  tradeIn: tradeInShape.isRequired,
  showModal: PropTypes.func.isRequired,
  configuration: configurationShape.isRequired
}

ManualSelect.propTypes = {
  id: PropTypes.string
}

export default injectIntl(Form.create({ name: 'manualSearchForm' })(ManualSearch))
